var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___TS1NdV",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___TS1NdV",
  "JN": "VoiceParticipantItem.module__participantRowDragging___TS1NdV",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___TS1NdV",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___TS1NdV",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___TS1NdV",
  "Kt": "VoiceParticipantItem.module__deviceIcon___TS1NdV",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___TS1NdV",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___TS1NdV",
  "zc": "VoiceParticipantItem.module__iconContainer___TS1NdV",
  "F8": "VoiceParticipantItem.module__participantName___TS1NdV",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___TS1NdV",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___TS1NdV",
  "_q": "VoiceParticipantItem.module__iconsContainer___TS1NdV",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___TS1NdV",
};

module.exports = exports;
